import { useState, useCallback } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import produce from 'immer'

import axios from 'utils/axios/modules/service'
import axios_credit from 'utils/axios/modules/pay'
import { getStorage } from 'utils/localstorage'
//import queryString from 'query-string'

async function requestService(id, setIsServiceRequestingAPI, setService, setServiceErrors) {
  setIsServiceRequestingAPI(true)

  await axios
    .getService(id)
    .then((response) => {
      setService(response.data)
    })
    .catch((errorMessages) => {
      setServiceErrors(errorMessages)
    })

  setIsServiceRequestingAPI(false)
}

async function requestServices(setIsServicesRequestingAPI, setServices, setServicesErrors) {
  setIsServicesRequestingAPI(true)

  await axios
    .getServices()
    .then((response) => {
      setServices(response.data)
    })
    .catch((errorMessages) => {
      setServicesErrors(errorMessages)
    })

  setIsServicesRequestingAPI(false)
}

async function requestCreditCard(id, setIsCreditCardRequestingAPI, setCreditCard, setCreditCardErrors) {
  setIsCreditCardRequestingAPI(true)

  await axios_credit
    .getCreditCard(id)
    .then((response) => {
      setCreditCard(response.data.credit_card)
    })
    .catch((errorMessages) => {
      setCreditCardErrors(errorMessages)
    })

  setIsCreditCardRequestingAPI(false)
}

async function requestCreditCardForList(services, setServices) {
  for (const index in services) {
    if (services[index].ninal_subscription_application.is_contractor) {
      await axios_credit.getCreditCard(services[index].dev_contractid).then((response) => {
        setServices((services) =>
          produce(services, (draftState) => {
            draftState[index].credit_card = { card_no: null }
            Object.assign(draftState[index], response.data)
          })
        )
      })
    }
  }
}

function useServiceHook() {
  // id関連
  const user_id = getStorage('crm_id')
  const { id } = useParams()

  // service関連
  const [service, setService] = useState({})
  const [isServiceRequestingAPI, setIsServiceRequestingAPI] = useState(false)
  const [serviceErrors, setServiceErrors] = useState([])
  const getService = useCallback(async () => {
    await requestService(id, setIsServiceRequestingAPI, setService, setServiceErrors)
  }, [id])

  // creditCard関連
  const [creditCard, setCreditCard] = useState({})
  const [isCreditCardRequestingAPI, setIsCreditCardRequestingAPI] = useState(false)
  const [creditCardErrors, setCreditCardErrors] = useState([])
  const getCreditCard = useCallback(async () => {
    await requestCreditCard(id, setIsCreditCardRequestingAPI, setCreditCard, setCreditCardErrors)
  }, [id])

  // services関連
  const [services, setServices] = useState([])
  const [isServicesRequestingAPI, setIsServicesRequestingAPI] = useState(false)
  const [servicesErrors, setServicesErrors] = useState([])
  const getServices = useCallback(async () => {
    await requestServices(setIsServicesRequestingAPI, setServices, setServicesErrors)
  }, [])
  const getCreditCardForList = useCallback(async () => {
    await requestCreditCardForList(services, setServices)
  }, [services])

  // モーダル関連
  const history = useHistory()
  const [modalDisplay, setModalDisplay] = useState(false)
  const [contractId, setContractId] = useState('')
  const close = () => {
    setModalDisplay(false)
  }
  const link = (id) => {
    history.push(`/pay/${contractId ? contractId : id}/edit`)
  }

  const goToProductInfo = (purchase_detail_ids) => {
    history.push(`/product-info`, {
      purchase_detail_ids,
      contractId,
    })
  }

  const PRODUCT_CLASSIFICATION = {
    フレーム: '10',
    サングラス: '30',
  }

  const isFrameOrSunglasses = (items) => {
    return items
      .map((item) => item.dev_product_classification)
      .some(
        (element) => element === PRODUCT_CLASSIFICATION['フレーム'] || element === PRODUCT_CLASSIFICATION['サングラス']
      )
  }

  const getContractItems = (subscription) => {
    const willReturnItem = Object.values(subscription.will_return_item).flat()
    if (willReturnItem && willReturnItem.length && isFrameOrSunglasses(willReturnItem)) {
      return willReturnItem
    }
    const newItem = Object.values(subscription.new_item).flat()
    if (newItem && newItem.length && isFrameOrSunglasses(newItem)) {
      return newItem
    }

    return []
  }

  const toTanakaSpecialURL = () => {
    window.location.href =
      'https://www.tanaka-megane.co.jp/special/ninal/?_gl=1*7xq7j1*_gcl_au*MTg4OTM2MzE0Ni4xNzM4NTY2MjQy*_ga*MTc3ODMyNTU0LjE3MjI1MDM1Mjk.*_ga_R5GJWEQ0MF*MTc0MDQ3NDcyMC4xNjAuMS4xNzQwNDc3MDUwLjYwLjAuNjA5OTY5Njc3%E3%80%8D%E3%81%B8%E9%81%B7%E7%A7%BB%E3%81%95%E3%82%8C%E3%82%8B%E3%81%93%E3%81%A8'
  }

  const resetErrors = () => {
    setServiceErrors([])
    setCreditCardErrors([])
  }

  const isServiceDetailLoading = isServiceRequestingAPI || isCreditCardRequestingAPI

  return {
    // id関連
    user_id: user_id,
    contractId: id,

    // service関連
    service,
    isServiceRequestingAPI,
    serviceErrors,
    setServiceErrors,
    getService,
    isServiceDetailLoading,
    resetErrors,

    // creditCard関連 TODO creditCardHookによせる。削除予定
    creditCard,
    isCreditCardRequestingAPI,
    creditCardErrors,
    setCreditCardErrors,
    getCreditCard,

    // services関連
    services,
    isServicesRequestingAPI,
    servicesErrors,
    setServicesErrors,
    getServices,
    getCreditCardForList,

    // モーダル関連
    modalDisplay,
    setModalDisplay,
    setContractId,
    close,
    link,
    getContractItems,
    PRODUCT_CLASSIFICATION,
    toTanakaSpecialURL,

    // product
    goToProductInfo,
  }
}

export default useServiceHook
